const moduleState = {
  resetMapZoom: false,
  resultsHover: false,
  embedModalOpen: false,
  embedModalLinkClicked: false,
  aboutModalOpen: false,
  aboutModalLinkClicked: false,
  evTermsModalOpen: false,
  evTermsModalLinkClicked: false,
  evHelpClicked: false,
  directionPopup: false,
  corridorPopup: false,
  activeTab: 'find',
  activeFindMode: 'nearest',
  activeAnalyzeTab: 'location',
  corridorsPresent: true,
  displayDirections: false,
  npsFunded: false,
  mobileView: false,
  landscapeView: false,
  mobileMapResize: false,
  alwaysMobile: false,
};

const moduleGetters = {
  getResetMapZoom: (state) => state.resetMapZoom,
  getResultsHover: (state) => state.resultsHover,
  getEmbedModalOpen: (state) => state.embedModalOpen,
  getEmbedModalLinkClicked: (state) => state.embedModalLinkClicked,
  getAboutModalOpen: (state) => state.aboutModalOpen,
  getAboutModalLinkClicked: (state) => state.aboutModalLinkClicked,
  getEvTermsModalOpen: (state) => state.evTermsModalOpen,
  getEvTermsModalLinkClicked: (state) => state.evTermsModalLinkClicked,
  getEvHelpClicked: (state) => state.evHelpClicked,
  getDirectionPopup: (state) => state.directionPopup,
  getCorridorPopup: (state) => state.corridorPopup,
  getNavActiveTab: (state) => state.activeTab,
  isCorridorsPresent: (state) => state.corridorsPresent,
  isDisplayDirections: (state) => state.displayDirections,
  isNavActiveTabFind: (state, getters) => getters.getNavActiveTab === 'find',
  isNavActiveTabAnalyze: (state, getters) => getters.getNavActiveTab === 'analyze',
  isNavActiveTabCorridors: (state, getters) => getters.getNavActiveTab === 'corridors',
  getNavActiveFindMode: (state) => state.activeFindMode,
  isNavActiveFindModeNearest: (state, getters) => (getters.isNavActiveTabFind && getters.getNavActiveFindMode === 'nearest'),
  isNavActiveFindModeNearestSearchPresent: (state, getters) => (getters.isNavActiveFindModeNearest && !!getters.getFilterValue('location')),
  isNavActiveFindModeRoute: (state, getters) => (getters.isNavActiveTabFind && getters.getNavActiveFindMode === 'route'),
  isNavActiveFindModeRouteSearchPresent: (state, getters) => (getters.isNavActiveFindModeRoute && !!getters.getFilterValue('start') && !!getters.getFilterValue('end')),
  isNavActiveTabCorridorsSearchPresent: (state, getters) => (getters.isNavActiveTabCorridors && !!getters.getFilterValue('start') && !!getters.getFilterValue('end')),
  getNavActiveAnalyzeTab: (state) => state.activeAnalyzeTab,
  isNavActiveAnalyzeTabLocation: (state, getters) => (getters.isNavActiveTabAnalyze && getters.getNavActiveAnalyzeTab === 'location'),
  isNavActiveAnalyzeTabFuel: (state, getters) => (getters.isNavActiveTabAnalyze && getters.getNavActiveAnalyzeTab === 'fuel'),
  isNavActiveAnalyzeTabStation: (state, getters) => (getters.isNavActiveTabAnalyze && getters.getNavActiveAnalyzeTab === 'station'),
  isNpsFunded: (state) => state.npsFunded,
  isMobileView: (state) => state.mobileView,
  isLandscapeView: (state) => state.landscapeView,
  isMobileMapResize: (state) => state.mobileMapResize,
  isAlwaysMobile: (state) => state.alwaysMobile,

  getNavActiveFilterRouteName: (state) => {
    if (state.activeTab === 'analyze') {
      return 'AnalyzeStations';
    }
    if (state.activeTab === 'corridors') {
      return 'CorridorStations';
    }
    if (state.activeFindMode === 'route') {
      return 'FindRouteStations';
    }
    return 'FindNearestStations';
  },

  hasNavStationResults: (state, getters) => {
    let hasResults = false;
    if (getters.isNavActiveFindModeNearest) {
      hasResults = getters.isNavActiveFindModeNearestSearchPresent;
    } else if (getters.isNavActiveFindModeRoute) {
      hasResults = getters.isNavActiveFindModeRouteSearchPresent;
    }
    return hasResults;
  },

  getNavActiveMapMode: (state, getters) => {
    let mapMode = state.activeTab;
    if (state.activeTab === 'find') {
      mapMode += `-${state.activeFindMode}`;
      if (getters.hasNavStationResults) {
        mapMode += '-results';
      }
    }

    return mapMode;
  },
};

const mutations = {
  setResetMapZoom(state, status) {
    state.resetMapZoom = status;
  },

  setResultsHover(state, status) {
    state.resultsHover = status;
  },

  setEmbedModalOpen(state, status) {
    state.embedModalOpen = status;
  },

  setEmbedModalLinkClicked(state, status) {
    state.embedModalLinkClicked = status;
  },

  setAboutModalOpen(state, status) {
    state.aboutModalOpen = status;
  },

  setAboutModalLinkClicked(state, status) {
    state.aboutModalLinkClicked = status;
  },

  setEvTermsModalOpen(state, status) {
    state.evTermsModalOpen = status;
  },

  setEvTermsModalLinkClicked(state, status) {
    state.evTermsModalLinkClicked = status;
  },

  setEvHelpClicked(state, status) {
    state.evHelpClicked = status;
  },

  setDirectionPopup(state, status) {
    state.directionPopup = status;
  },

  setCorridorPopup(state, status) {
    state.corridorPopup = status;
  },

  setNavActive(state, payload) {
    if (payload.activeTab) {
      state.activeTab = payload.activeTab;
    }

    if (payload.activeFindMode) {
      state.activeFindMode = payload.activeFindMode;
    }
  },

  setCorridorsPresent(state, bool) {
    state.corridorsPresent = bool;
  },

  setNpsStations(state, bool) {
    state.npsFunded = bool;
  },

  setDisplayDirections(state, bool) {
    state.displayDirections = bool;
  },

  setNavActiveAnalyzeTab(state, tab) {
    state.activeAnalyzeTab = tab;
  },

  resizeMobileMap(state, bool) {
    state.mobileMapResize = bool;
  },

  setMobileDisplay(state, bool) {
    state.mobileView = bool;
  },

  setLandscapeDisplay(state, bool) {
    state.landscapeView = bool;
  },

  setAlwaysMobile(state, bool) {
    state.alwaysMobile = bool;
  },
};

export default {
  state: moduleState,
  getters: moduleGetters,
  mutations,
};
